<template>
	<div
		:id="`structured-data-${_uid}`"
		class="c-block-list-structured-data-custom w-fit mx-auto"
	>
		<StructuredData
			v-if="!empty"
			:cells="data.cells"
			:use-first-row-as-header="data.useFirstRowAsHeader"
			:use-first-column-as-header="data.useFirstColumnAsHeader"
			:first-row-sticky="true"
			:first-column-sticky="true"
			class="s-structured-data w-5col >=768:w-8col max-w-full"
		>
			<template v-if="title" #default>
				<caption class="block w-full text-left">
					<LongReadTarget
						v-if="title"
						:container-id="`structured-data-${_uid}`"
						:title="title"
					>
						<BaseH2
							class="text-primary-button mb-sm"
							v-text="title"
						/>
					</LongReadTarget>
				</caption>
			</template>
		</StructuredData>
	</div>
</template>

<script>
import LongReadTarget from '~/citi-baseline/components/LongReadTarget';
import StructuredData from '~/citi-baseline/components/StructuredData.vue';

export default {
	name: 'BlockListStructuredDataCustom',
	components: { LongReadTarget, StructuredData },
	inheritAttrs: false,

	props: {
		title: {
			type: String,
			required: false,
		},
		data: {
			type: Object,
			required: false,
		},
	},

	data() {
		let empty = !this.data?.cells?.length;

		if (!empty) {
			empty = !this.data.cells.filter((row) => {
				return row.filter((cell) => cell.value).length;
			}).length;
		}

		return {
			empty,
		};
	},
};
</script>
